import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { LocalizationProvider, DatePicker } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";
import { Button } from "@mui/material";
import client from "../../../Common/Client/Client";
import BusLayout from "./BusLayout";
import TicketBookingForm from "./TicketBookingForm";

const AdminBooking = () => {
  const [selectedDate, setSelectedDate] = useState(dayjs());
  const [bookedSeat, setBookedSeat] = useState([]);
  const [layout, setLayout] = useState([]);
  const [isPending, setIsPending] = useState(false);
  const [adminSelectSeat, setAdminSelectSeat] = useState([]);
  const [packageDetails, setPackageDetails] = useState([]);
  const [availableSeat, setAvailableSeat] = useState([]);

  const seatLockData = async () => {
    setIsPending(true);
    const dateObj = new Date(selectedDate);
    const day = String(dateObj.getUTCDate()).padStart(2, "0");
    const month = String(dateObj.getUTCMonth() + 1).padStart(2, "0");
    const year = dateObj.getUTCFullYear();
    const formatDate = `${day}/${month}/${year}`;

    try {
      const response = await client.get(`/admin-lock/lock?date=${formatDate}`, {
        withCredentials: true,
      });
      if (response.status === 200) {
        const lockedSeatId = response?.data?.lockedSeat
          ? response?.data?.lockedSeat.bookings.map((each) => each.id)
          : [];
        setBookedSeat(lockedSeatId);
        setLayout(response?.data?.seatLayout);
        setPackageDetails(response?.data?.packageData);
        setIsPending(false);
      }
    } catch (error) {
      console.log(error);
    }
  };

  // console.log(bookedSeat);

  return (
    <>
      <main id="main">
        <div className="pagetitle">
          <nav>
            <ol className="breadcrumb">
              <li className="breadcrumb-item">
                <Link to="/">Home</Link>
              </li>
              <li className="breadcrumb-item active">Admin Seat Lock</li>
            </ol>
          </nav>
        </div>
        <section>
          <div className="card" style={{ width: "100%" }}>
            <div style={{ padding: "20px" }}>
              <h5
                className="card-title"
                style={{ textAlign: "center", marginBottom: "20px" }}
              >
                Seat Booking
              </h5>
              <div className="row">
                <div className="offset-md-3 col-md-6">
                  <div>
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                      <DatePicker
                        label="Select Travel Date"
                        value={selectedDate}
                        format="DD/MM/YYYY"
                        onChange={(newValue) => {
                          setSelectedDate(newValue);
                        }}
                        slotProps={{ textField: { fullWidth: true } }}
                      />
                    </LocalizationProvider>
                  </div>
                  <div>
                    <Button
                      variant="contained"
                      className=""
                      onClick={seatLockData}
                      // disabled={open}
                      style={{
                        backgroundColor: "#e89e25 ",
                        marginTop: "10px",
                      }}
                    >
                      Seat Filter
                    </Button>
                  </div>
                </div>
                <div className="col-md-4 d-flex justify-content-center align-items-start mt-5">
                  <BusLayout
                    bookedSeat={bookedSeat}
                    layout={layout}
                    setAdminSelectSeat={setAdminSelectSeat}
                    adminSelectSeat={adminSelectSeat}
                    setAvailableSeat={setAvailableSeat}
                    availableSeat={availableSeat}
                  />
                </div>

                <div className="col-md-8 mt-5">
                  <TicketBookingForm
                    selectedDate={selectedDate}
                    adminSelectSeat={adminSelectSeat}
                    packageDetails={packageDetails}
                    seatLockData={seatLockData}
                    setAdminSelectSeat={setAdminSelectSeat}
                    availableSeat={availableSeat}
                  />
                </div>
              </div>
            </div>
          </div>
        </section>
      </main>
    </>
  );
};

export default AdminBooking;
